import React from 'react';
import ContactForm from '../components/ContactForm';

export default function ContactSection() {
  return (
    <section id="contact" className="sec" style={{ background: 'var(--stone)' }}>
      <div className="rv">
        <div className="kicker k-dk">Get in Touch</div>
        <h2 className="title dk">
          Let&apos;s build
          <br />
          <em>something remarkable</em>
        </h2>
      </div>
      <div className="con-grid">
        <div className="rl">
          <div className="con-info">
            <div>
              <div className="c-lbl">Website</div>
              <div className="c-val">www.auraluxmaterials.com</div>
            </div>
            <div>
              <div className="c-lbl">General Inquiries</div>
              <div className="c-val">info@auraluxmaterials.com</div>
            </div>
            <div>
              <div className="c-lbl">Technical Support</div>
              <div className="c-val">Tech@auraluxmaterials.com</div>
            </div>
            <div>
              <div className="c-lbl">Response Time</div>
              <div className="c-val">Within 24 business hours</div>
            </div>
          </div>
          <div className="con-map">
            <h4>Global Presence</h4>
            <p>Manufacturing · Technical Service · Distribution</p>
            <div className="loc l-in">India — Headquarters &amp; Primary Manufacturing</div>
            <div className="loc l-ae">United Arab Emirates — Middle East &amp; Africa Hub</div>
            <div className="loc l-sg">Southeast Asia — Regional Sales &amp; Technical</div>
          </div>
        </div>
        <ContactForm />
      </div>
    </section>
  );
}
